export function formatCoords(lat, lng) {
  const latValue = Number(lat);
  const lngValue = Number(lng);
  if (!Number.isFinite(latValue) || !Number.isFinite(lngValue)) {
    return "";
  }
  return `${latValue.toFixed(5)},${lngValue.toFixed(5)}`;
}

export function normalizeCoords(value) {
  if (!value) return "";

  const parts = value.toString().replace(/\s+/g, "").split(",");
  if (parts.length !== 2) {
    return value.trim().replace(/\s+/g, "");
  }

  const lat = Number(parts[0]);
  const lng = Number(parts[1]);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return "";
  }

  return formatCoords(lat, lng);
}

export function buildSizeValue({ sizeUnit, size, sizeFeet, sizeInches }) {
  if (sizeUnit === "ft-in") {
    const parts = [];
    const feet = sizeFeet.trim();
    const inches = sizeInches.trim();

    if (feet) parts.push(`${feet} ft`);
    if (inches) parts.push(`${inches} in`);

    return parts.join(" ").trim();
  }

  return size.trim();
}

export function buildWeightValue({ weightUnit, weight, weightLb }) {
  if (weightUnit === "lb") {
    const trimmed = weightLb.trim();
    if (!trimmed) return "";
    return /\blb?s?\b/i.test(trimmed) ? trimmed : `${trimmed} lb`;
  }

  return weight.trim();
}

export function normalizeTime(value) {
  if (!value) return null;

  if (/^\d{2}:\d{2}$/.test(value)) return value;

  const match = value.match(/(\d+):(\d+)\s?(AM|PM)/i);
  if (!match) return null;

  let [, hour, minute, meridiem] = match;
  let parsedHour = parseInt(hour, 10);

  if (meridiem.toUpperCase() === "PM" && parsedHour !== 12) {
    parsedHour += 12;
  }
  if (meridiem.toUpperCase() === "AM" && parsedHour === 12) {
    parsedHour = 0;
  }

  return `${parsedHour.toString().padStart(2, "0")}:${minute}`;
}

export function hasRequiredCatchMedia(selectedFile) {
  return Boolean(selectedFile);
}

export function buildCatchPayload({
  fishInput,
  waterType,
  wayOfFishing,
  typeOfFishing,
  style,
  customStyle,
  technique,
  rod,
  reel,
  braid,
  leader,
  lure,
  lureSize,
  lureColor,
  hookBrand,
  hookSpec,
  knotBraidToLeader,
  knotLeaderToLure,
  catchAndRelease,
  coordinates,
  isLocationPublic,
  location,
  exifDate,
  exifTime,
  rating,
  feedback,
  caption,
  sizeUnit,
  size,
  sizeFeet,
  sizeInches,
  weightUnit,
  weight,
  weightLb,
}) {
  const finalStyle = style === "Other" ? customStyle : style;
  const [selectedHookType, selectedHookSize] = hookSpec
    ? hookSpec.split("|")
    : ["", ""];

  const formattedCoords = normalizeCoords(coordinates);
  const finalSize = buildSizeValue({ sizeUnit, size, sizeFeet, sizeInches });
  const finalWeight = buildWeightValue({ weightUnit, weight, weightLb });
  const finalWaterType = waterType === "all" ? "" : waterType;

  return {
    fish: fishInput,
    size: finalSize,
    weight: finalWeight,
    waterType: finalWaterType,
    wayOfFishing,
    typeOfFishing,
    style: finalStyle,
    technique,
    rod,
    reel,
    braid,
    leader,
    lure,
    lureSize,
    lureColor,
    hookBrand,
    hookType:
      selectedHookType === "single"
        ? "Single Hook"
        : selectedHookType === "treble"
          ? "Treble Hook"
          : "",
    hookSize: selectedHookSize || "",
    knotBraidToLeader,
    knotLeaderToLure,
    catchAndRelease,
    coordinates: formattedCoords || "",
    isLocationPublic,
    location: location || "",
    date: exifDate || "",
    time: exifTime || "",
    historicalContext: null,
    rating,
    feedback,
    notes: caption || "",
  };
}
